import { useState } from 'react';

export default function PortfolioSection() {
  const [activeTab, setActiveTab] = useState('all');

  // Removed TypeScript type annotation for plain JavaScript compatibility
  const talents = [
    {
      id: 1,
      name: '輝煌ステラ',
      nameEn: 'Kikou Stellar',
      category: '0期生',
      image: 'https://static.readdy.ai/image/d75fec4e7190184da25e8230de51a6ef/1328c1ac50d4204845a522bc15cd402a.png',
      tags: ['歌', 'ゲーム', 'トーク'],
      color: 'from-pink-500 to-purple-500'
    },
    {
      id: 2,
      name: '白戌ちゃちゃまる',
      nameEn: 'Byakui Chachamaru',
      category: '1期生',
      image: 'https://static.readdy.ai/image/d75fec4e7190184da25e8230de51a6ef/54d87947e87c78c2d20e855797814132.jpeg',
      tags: ['歌', 'ゲーム', 'トーク'],
      color: 'from-cyan-500 to-blue-500'
    }
  ];

  const categories = [
    { id: 'all', label: 'ALL' },
    { id: '0期生', label: '0期生' },
    { id: '1期生', label: '1期生' },
    { id: '2期生', label: '2期生' },
    { id: '3期生', label: '3期生' },
  ];

  const filteredTalents = activeTab === 'all'
    ? talents
    : talents.filter(t => t.category === activeTab);

  return (
    <section id="talents" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-block bg-gradient-to-r from-pink-100 to-cyan-100 rounded-full px-6 py-2 mb-4">
            <span className="text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-cyan-500">TALENTS</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-gray-900">所属</span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-cyan-500">タレント</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            個性豊かなタレントたちが、毎日楽しい配信をお届けしています
          </p>
        </div>

        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-gray-100 rounded-full p-1">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveTab(cat.id)}
                className={`px-6 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === cat.id
                    ? 'bg-gradient-to-r from-pink-500 to-cyan-500 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {filteredTalents.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredTalents.map((talent) => (
              <div
                key={talent.id}
                className="group relative bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
              >
                <div className="relative overflow-hidden">
                  <div className="w-full h-96">
                    <img
                      src={talent.image}
                      alt={talent.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className={`absolute inset-0 bg-gradient-to-t ${talent.color} opacity-0 group-hover:opacity-20 transition-opacity`}></div>
                  <div className="absolute top-4 left-4">
                    <span className={`inline-block bg-gradient-to-r ${talent.color} text-white text-xs font-bold px-3 py-1.5 rounded-full`}>
                      {talent.category}
                    </span>
                  </div>
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full w-10 h-10 flex items-center justify-center">
                    <i className="ri-tiktok-fill text-gray-900 text-lg"></i>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-1">{talent.name}</h3>
                  <p className="text-sm text-gray-500 mb-4">{talent.nameEn}</p>
                  <div className="flex flex-wrap gap-2">
                    {talent.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="text-xs bg-gray-100 text-gray-600 px-3 py-1 rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-pink-100 to-cyan-100 rounded-full flex items-center justify-center">
              <i className="ri-user-star-line text-4xl text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-cyan-500"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Coming Soon</h3>
            <p className="text-gray-600 max-w-md mx-auto">
              新しいタレントの発表をお楽しみに！<br />
              オーディションも随時開催中です。
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
